import { Painel } from './paginas/Painel'

/**
 * Página inicial do portal.
 *
 * Era um cartão chamado "Fundação visual" com onze botões soltos e o aviso de
 * que *"as telas de negócio chegam nas próximas entregas"*. Elas chegaram — e a
 * navegação virou a casca (menu à esquerda, barra superior).
 *
 * O que sobra para a home é a pergunta do plantão: **está de pé agora?** Por
 * isso ela é o painel de 24 horas, e não uma lista de atalhos que o menu já dá.
 */
export default function App() {
  return <Painel />
}
